import React from 'react'

const DangerAlertIcon = ({width=17,height=17}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.50021 6.267V9.19442M1.23789 11.8299C0.561849 13.0008 1.40729 14.4638 2.75858 14.4638H14.2418C15.5924 14.4638 16.4378 13.0008 15.7625 11.8299L10.0217 1.87822C9.34565 0.707259 7.65478 0.707259 6.97874 1.87822L1.23789 11.8299ZM8.50021 11.5363H8.50568V11.5426H8.50021V11.5363Z" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default DangerAlertIcon